import React from 'react'
import { Flex } from '@chakra-ui/react'

export default function Layout(props) {
  return (
    <Flex flexDirection={'column'} flex={100} {...props}>
      {props.children}
    </Flex>
  )
}
